var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"md":"6","offset-md":"3"}},[_c('v-alert',{attrs:{"outlined":"","prominent":"","color":"blue"},domProps:{"innerHTML":_vm._s(_vm.message)}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }